import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import { handleChange } from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";
import CommonSelect from "../../../components/forms/CommonSelect";

function FastMigracaoModal({ modalHook, valuesHook, fastProcesso }) {
  const { values, setValues } = valuesHook;
  const { fastMigracaoModal, setFastMigracaoModal } = modalHook;

  return (
    <CommonModal
      title="Fast processo"
      is_open_modal={fastMigracaoModal}
      set_is_open_modal={setFastMigracaoModal}
      size="lg"
      buttons={
        <>
          <CommonButton
            key={`novo-usuario`}
            color="success"
            onClick={fastProcesso}
          >
            Salvar
          </CommonButton>
        </>
      }
    >
      <div className="row">
        <div className="col-lg-6 items-center">
          <CommonSelect
            label="Etapa"
            id="step"
            value={values.step}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={[
              { id: "1", text: "1" },
              { id: "2", text: "2" },
              { id: "3", text: "3" },
              { id: "4", text: "4" },
            ]}
          />
        </div>
      </div>
    </CommonModal>
  );
}

FastMigracaoModal.propTypes = {
  modalHook: PropTypes.shape({
    fastMigracaoModal: PropTypes.bool.isRequired,
    setFastMigracaoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  fastProcesso: PropTypes.func.isRequired,
};

export default FastMigracaoModal;
